export const ROUTES = {
  ADMIN_CREATE_USER: 'users',
  ADMIN_GET_USERS: 'users',
  ADMIN_RESET_PASSWORD: (userId: string) => `users/${userId}/reset-password`,
  ADMIN_UPDATE_USER: (userId: string) => `users/${userId}`,
  ADMIN_UPDATE_CUSTOMER: (customerId: string) => `customers/${customerId}`,
  ADMIN_GET_HISTORY_VEHICLE: (vehicleId: string) => `vehicle-orders/vehicle/${vehicleId}`,
  ADMIN_GET_CUSTOMERS: 'customers',
  ADMIN_GET_ORDERS_HISTORY: 'orders-history',
  ADMIN_GET_ORDER_HISTORY_DETAIL: (orderId: string) => `orders-history/${orderId}`,
  ADMIN_FINALIZE_ORDER_HISTORY: (orderId: string) => `orders-history/${orderId}`,
  ADMIN_RECEIPT_PREVIEW: (orderId: string) => `receipts/order/${orderId}/preview`,
  ADMIN_RECEIPT_PDF: (orderId: string) => `receipts/order/${orderId}/pdf`,
  ADMIN_RECEIPT_PAY: (receiptId: string) => `receipts/${receiptId}/pay`,
  ADMIN_WORK_SUMMARY: (orderId: string) => `work-summary/order/${orderId}`,
  ADMIN_GET_SERVICES_CATALOG: 'catalog/services',
  AUTH_CHANGE_PASSWORD: 'auth/change-password',
  AUTH_LOGIN: 'auth/login',
  AUTH_LOGOUT: 'auth/logout',
  AUTH_REFRESH: 'auth/refresh',
  CATALOG_CREATE_VEHICLE_BRAND: 'catalog/brands/create-vehicle-brand',
  CATALOG_GET_ROLES: 'catalog/admin/roles',
  CATALOG_SERVICE_CATEGORIES: 'catalog/services/categories',
  CATALOG_SERVICES: 'catalog/services',
  CATALOG_UPDATE_SERVICES: (id: string) => `catalog/services/${id}`,
  DASHBOARD_SUMMARY: 'dashboard/summary',
  HOME_RECEPTION: 'work-orders/vehicles',
  LOOKUP_ACQUISITION_SOURCE_OPTIONS: 'lookup/ACQUISITION_SOURCE',
  LOOKUP_BRAND_CARS: 'lookup/brands-vehicles',
  LOOKUP_CARS_MODELS_BY_BRAND: (brandId?: string) =>
    brandId ? `lookup/models-vehicles/${brandId}` : 'lookup/models-vehicles',
  LOOKUP_CARS_VERSIONS_BY_MODEL: (modelId: string) =>
    `lookup/versions-vehicles/${modelId}`,
  LOOKUP_CARS_YEARS_AND_ENGINES_CC: 'lookup/years-enginecc-vehicles',
  LOOKUP_DOCUMENT_TYPE_OPTIONS: 'lookup/DOCUMENT_TYPE',
  OPS_QUOTES_ADD_APPROVAL_EVIDENCE: (quoteId: string) =>
    `quotes/${quoteId}/approval-evidence`,
  OPS_QUOTES_ADD_ITEMS: (quoteId: string) => `quotes/${quoteId}/items`,
  OPS_QUOTES_APPROVE: (quoteId: string) => `quotes/${quoteId}/approve`,
  OPS_QUOTES_CREATE_NEW: (orderId: string) => `quotes/${orderId}/versions`,
  OPS_QUOTES_GET_OR_CREATE: (orderId: string) => `quotes/${orderId}`,
  OPS_QUOTES_LIST: 'quotes',
  OPS_QUOTES_PUBLIC_BY_TOKEN: (token: string) => `quotes/public/${token}`,
  OPS_QUOTES_REMOVE_ITEMS: (quoteId: string) => `quotes/${quoteId}/remove-items`,
  OPS_QUOTES_SEND: (quoteId: string) => `quotes/${quoteId}/send`,
  OPS_QUOTES_UPDATE_ITEMS: (quoteId: string) => `quotes/${quoteId}/items`,
  OPS_REQUOTE_CREATE: 're-quote',
  OPS_RECEPTION_BRANDS: 'catalog/brands',
  OPS_RECEPTION_CANCEL_ORDER: (orderId: string) => `work-orders/${orderId}/cancel`,
  OPS_RECEPTION_CREATE_CUSTOMER: 'customers',
  OPS_RECEPTION_CREATE_ORDER: 'work-orders',
  OPS_RECEPTION_CREATE_VEHICLE: 'vehicles',
  OPS_RECEPTION_CREATE_VERSION_VEHICLE: 'vehicles/find-or-create-version',
  OPS_RECEPTION_DOCUMENT_LOOKUP: 'customers/search/document',
  OPS_RECEPTION_MODELS_BY_BRAND: 'catalog/models/by-brand',
  OPS_RECEPTION_PLATE_LOOKUP: (plate: string) => `vehicles/search/plate/${plate}`,
  OPS_RECEPTION_SERVICES_SEARCH: (vehicleVersionId: string) =>
    `catalog/services/services-all/${vehicleVersionId}`,
  OPS_RECEPTION_UPDATE_CUSTOMER: (customerId: string) => `customers/${customerId}`,
  OPS_TECHNICAL_REVIEW_EVIDENCES: (orderId: string) =>
    `technical-reviews/${orderId}/evidences`,
  OPS_TECHNICAL_REVIEW_EVIDENCE: (orderId: string, evidenceId: string) =>
    `technical-reviews/${orderId}/evidences/${evidenceId}`,
  OPS_UPDATE_TECHNICAL_REVIEW: 'technical-reviews',
  OPS_UPLOADS_PRESIGNED_URLS: 'uploads/presigned-urls',
  OPS_WORK_ORDER_ADD_EVIDENCES: (orderId: string) => `work-orders/${orderId}/evidences`,
  OPS_WORK_ORDER_BY_STATUS: (status: string) => `work-orders/status/${status}`,
  OPS_WORK_ORDER_REVIEW: (orderId: string) => `technical-reviews/retoma/order/${orderId}`,
  OPS_WORK_ORDER_TAKE: 'work-orders/take',
  OPS_WORK_ORDERS: 'work-orders',
  OPS_SERVICE_ORDERS_ASSIGN: (orderId: string) => `service-orders/${orderId}/assign`,
  OPS_SERVICE_ORDERS_DETAIL_WORKER: (orderId: string) => `service-orders/${orderId}`,
  OPS_SERVICE_ORDERS_START_SERVICE: (orderId: string, worOrderItemId: string) =>
    `service-orders/start-service/${orderId}/${worOrderItemId}`,
  OPS_SERVICE_ORDERS_UPDATE_SERVICE: (orderId: string, worOrderItemId: string) =>
    `service-orders/update-service/${orderId}/${worOrderItemId}`,
  OPS_SERVICE_ORDERS_SAVE_SERVICES: (orderId: string) =>
    `service-orders/bulk-update-service/${orderId}`,
  OPS_SERVICE_ORDERS_FINALIZE: (orderId: string) =>
    `service-orders/finalize-order/${orderId}`,
  OPS_SERVICE_ORDERS_CHANGE_TECHNICIAN: (orderId: string) =>
    `service-orders/change-technician/${orderId}`,
  PUBLIC_CUSTOMER_PORTAL_BY_UUID: (uuid: string) =>
    `customer-portal/status-vehicle/${uuid}`,
} as const;
